import { useEffect } from 'react';
import classNames from 'classnames/bind';
import { Link, useLocation } from 'react-router-dom';
import loadable from '@utils/loadable';

import withComponentName from '../../../../decorators/withComponentName';
import withMetatag from '../../../../decorators/metadataDecorators/metatagsTitleDecorator';

import FAQ from '../../../../data/histoticalDataApi';

import Styles from './style.module.scss';

import HistoricalImg1 from '../../../../assets/historical/h1.svg';
import HistoricalImg3 from '../../../../assets/historical/h3.svg';
import HistoricalImg4 from '../../../../assets/historical/h4.svg';

const PricingFAQ = loadable(() => import('../APIFinancialNewsPricing/PricingFAQ'));
const PricingFAQFooter = loadable(() => import('../APIFinancialNewsPricing/PricingFAQ/PricingFAQFooter'));
const PricingForm = loadable(() => import('../APIFinancialNewsPricing/PricingForm'));
const CTAbuttons = loadable(() => import('../../../Header/MainHeaderComponent/CTAbuttons'));
const MobileAnchorButtons = loadable(() => import('../../../MobileAnchorButtons'));

const cx = classNames.bind(Styles);

const HistoricalDataPromo = () => {
  const location = useLocation();

  useEffect(() => {
    const { hash } = location;
    if (hash !== '') {
      setTimeout(
        () => {
          const id = hash.replace('#', '');
          const element = document.getElementById(id);
          if (element) {
            element.scrollIntoView();
          }
        },
        0,
      );
    }
  }, [location]);

  return (
    <div className={cx('HDPromo')}>
      <div className={cx('HDPromo__container')}>
        <section className={cx('HDPromo__Header')}>
          <h1>Historical Data For Better Research</h1>
          <p>
            Old news isn&#39;t useless!
            <br />
            Historical data for backtesting, research, and strategy development.
            <br />
            Combine with our
            {' '}
            <Link to="/products/api/financial-news/pricing-api/commercial">Real-Time API Plans</Link>
            {' '}
            for the whole picture.
          </p>
        </section>

        <section className={cx('HDPromo__Launch')}>
          <div className={cx('HDPromo__Launch--features')}>
            <div className={cx('Feature-item')}>
              <img src={HistoricalImg1} alt="historical 1" />
              <span>
                Up to 5 years of data
                via CSV format
              </span>
            </div>
            <div className={cx('Feature-item')}>
              <img src={HistoricalImg3} alt="historical 1" />
              <span>
                Natural language understanding
                {' '}
                <a href="/nlp-nlu-machine-learning-for-financial-news-tweets-research">(NLU)</a>
                {' '}
                tags, sentiment analysis, and analytics for each story
              </span>
            </div>
            <div className={cx('Feature-item')}>
              <img src={HistoricalImg4} alt="historical 1" />
              <span>
                Up to 50% off for academia
                and non-profits
              </span>
            </div>
          </div>
        </section>

        <section className={cx('HDPromo__ContactUs')} id="contactus-form">
          <span className={cx('HDPromo__ContactUs--title')}>Get Historical Data</span>
          <span className={cx('HDPromo__ContactUs--sub-title')}>
            Contact us to get historical data.
            Please include your target universe to speed up the process.
          </span>
          <PricingForm />
        </section>

        <section className={cx('HDPromo__FAQ')}>
          <PricingFAQ FAQList={FAQ} />
        </section>

        <section className={cx('HDPromo__FAQ-footer')}>
          <PricingFAQFooter />
        </section>
      </div>
      <MobileAnchorButtons>
        <CTAbuttons
          contactUsLeadsToForm
          path="/products/api/financial-news/pricing-api/commercial"
          ctaButtonType="mobileAnchorButton"
        />
      </MobileAnchorButtons>
    </div>
  );
};

export default withComponentName(
  withMetatag(HistoricalDataPromo, 'products/api/financial-news/pricing-historical'),
);
